import React from 'react';
import PropTypes from 'prop-types';
import { Controlled as CodeMirror } from 'react-codemirror2';
import 'codemirror/addon/lint/lint';
import 'codemirror/addon/lint/javascript-lint';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/addon/edit/closebrackets';
import { JSHINT } from 'jshint';
// Add JSHINT to window
window.JSHINT = JSHINT;

export default class ConfigureForm extends React.Component {
  static propTypes = {
    beautifyConfigState: PropTypes.func.isRequired,
    cancelForm: PropTypes.func.isRequired,
    configuration: PropTypes.string.isRequired,
    deleteConfig: PropTypes.func.isRequired,
    isEdit: PropTypes.bool.isRequired,
    platformCode: PropTypes.string.isRequired,
    submitFunction: PropTypes.func.isRequired,
    updateConfigState: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    const { beautifyConfigState, cancelForm, deleteConfig, submitFunction } = this.props;
    this.beautifyConfigState = beautifyConfigState.bind(this);
    this.cancelForm = cancelForm.bind(this);
    this.deleteConfig = deleteConfig.bind(this);
    this.submitConfig = submitFunction.bind(this);
  }

  updateJSON = (editor, data, jsonString) => {
    const { updateConfigState } = this.props;
    updateConfigState(jsonString);
  };

  renderDefault = platformName => {
    const { configuration, isEdit } = this.props;
    return (
      <div>
        <p>
          <strong>Platform:</strong> {platformName}
        </p>
        <p>
          <button type="button" className="btn btn-secondary" onClick={this.cancelForm}>
            Cancel
          </button>&nbsp;
          {isEdit ? (
            <button type="button" className="btn btn-secondary" onClick={this.deleteConfig}>
              Delete Configuration
            </button>
          ) : null}
          &nbsp;
          <button type="submit" className="btn btn-primary" onClick={this.submitConfig}>
            {isEdit ? 'Update Configuration' : 'Set Configuration'}
          </button>
          <button
            type="button"
            className="btn btn-primary pull-right"
            onClick={this.beautifyConfigState}
          >
            Clean Code
          </button>
        </p>
        <CodeMirror
          onBeforeChange={this.updateJSON}
          options={{
            autoCloseBrackets: true,
            gutters: ['CodeMirror-lint-markers'],
            indentWithTabs: true,
            lineNumbers: true,
            lineWrapping: true,
            lint: true,
            mode: { name: 'javascript', json: true },
          }}
          value={configuration}
        />
      </div>
    );
  };

  render() {
    const { platformCode } = this.props;
    switch (platformCode) {
      case 'SFDC': {
        return this.renderDefault('SalesForce');
      }
      case 'ELOQUA': {
        return this.renderDefault('Oracle Eloqua');
      }
      case 'MARKETO': {
        return this.renderDefault('Marketo');
      }
      case 'HUBSPOT': {
        return this.renderDefault('Hubspot');
      }
      case 'CSV': {
        return this.renderDefault('CSV');
      }
      case 'DYNAMICS': {
        return this.renderDefault('MS Dynamics');
      }
      default: {
        return <p> Configuration for this platform is coming soon</p>;
      }
    }
  }
}
